import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, colors } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

export const textProminent: CSSProperties = {
  fontSize: 12,
  lineHeight: 1.3,
  color: colors.blueCool.standard,
  fontWeight: 600,
  textTransform: "uppercase",
};

export const flatButton: CSSProperties = {
  lineHeight: "24px",
  padding: "0 24px",
  paddingLeft: 8,
  paddingTop: 2,
  color: greys.slate,
  justifyContent: "flex-start",
};

export const flatButtonIcon: CSSProperties = {
  marginRight: spacing.std,
  paddingBottom: 2,
};

export const manage: CSSProperties = {
  color: greys.slate,
  paddingTop: 20,
  fontSize: 14,
  display: "flex",
  flexDirection: "row",
  lineHeight: "20px",
};

export const infoIcon: CSSProperties = {
  color: greys.cloudyBlue,
  marginTop: 1,
  marginRight: 8,
  height: 18,
  width: 18,
};

export const timelapseIcon = {
  style: {
    height: 18,
    width: 18,
    marginRight: 12,
    flexShrink: 0,
  } as CSSProperties,
  htmlColor: greys.blueGrey,
};

export const duration: CSSProperties = {
  display: "flex",
  padding: "10px 0 20px 0",
};

export const divider: CSSProperties = {
  marginTop: 20,
  marginBottom: 20,
};
